import React, { useEffect, useMemo, useState } from 'react';
import { Field } from 'redux-form';
import ScreeningFormGeneralField from '../ScreeningFormGeneralField/ScreeningFormGeneralField';
import PlaceMap from '../../../Places/PlaceMap/PlaceMap';
import { Button, ButtonGroup, Col, InputGroup, InputGroupAddon, Label, Row } from 'reactstrap';
import { Card, CardBody, CardTitle, CardText } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { updateScreeningProperty, updateScreeningPlace } from '../../../../redux';

const ScreeningFormMap = ({ isLoading, places, placeId }) => {
    const { t }                           = useTranslation();
    const dispatch                        = useDispatch();
    const [currentPlace, setCurrentPlace] = useState(placeId);
    const { screening }                   = useSelector(state => state.screenings);

    const updateMap = (values) => {
        let payload = {
            _id: values._id,
            cinema_hall: values.cinema_hall
        };
        dispatch(updateScreeningProperty(payload, "cinema_hall"));
    }

    const updatePlace = (placeId) => {
        dispatch(updateScreeningPlace({}));
        // we add a timeout here to force an update of the PlaceMap
        // component below
        setTimeout(() => {
            const newPlace = places.find(p => p._id === placeId);
            dispatch(updateScreeningPlace(newPlace));
        }, 0);
    }

    const place = screening?.cinema_hall || {};
    const hasMap = 'map' in place;
    const infos = {
        'name': place.name,
        'building': place.cinema,
        'number': place.number,
        'address':place.address,
        'zip': place.zip,
        'city': place.city,
        'state': place.state,
        'country': place.country,
        'coordinates': [place.coordinates?.lat, place.coordinates?.long].filter(v => !!v)?.join(', '),
        'capacity_total': place.capacity?.total,
        'capacity_prm': place.capacity?.prm
    };

    return (
        <div className='ScreeningFormMap'>
            <ScreeningFormGeneralField onSubmit={(values) => updateMap(values)}>
                <Row>
                    <Col sm={hasMap ? 2 : 12}>
                        <CardBody>
                            <CardTitle>
                                <h3 className="border-bottom border-dark">{t('places.place', {count: 1})}</h3>
                                <Field component="select" className='form-control' name="cinema_hall._id" onChange={(e) => updatePlace(e.target.value)}>
                                    {places.map(p =>
                                        <option key={p._id} value={p._id} >
                                            {p.name}
                                        </option>
                                    )}
                                </Field>
                            </CardTitle>
                            <CardText tag="div">
                                { Object.keys(infos).filter(key => !!infos[key]).map(key => (
                                    <Row>
                                        <Col sm={hasMap ? 12 : 6} className={`text-${hasMap ? 'left' : 'right'} text-bold`}>
                                            { t(`places.${key}`) }
                                        </Col>
                                        <Col className="text-left">{ infos[key] }</Col>
                                    </Row>
                                ))}
                            </CardText>
                        </CardBody>
                    </Col>
                    { hasMap && (
                        <Col sm={10}>
                            <CardBody>
                                <CardText tag="div">
                                    <Field component={PlaceMap} name="cinema_hall.map" screeningSeats={screening?.cinema_hall?.map?.seats || []} />
                                </CardText>
                            </CardBody>

                        </Col>
                    )}
                </Row>
                <Row>
                    <Col className="text-center">
                        <ButtonGroup>
                            <Button type="submit" color="success" disabled={isLoading}>
                                {isLoading ?
                                    <span>
                                        &nbsp;<i className="fa fa-spinner fa-spin"></i>
                                    </span>
                                    :
                                    <span>
                                        <i className="fa fa-save"></i>&nbsp;
                                        {t("common.save")}
                                    </span>
                                }
                            </Button>
                        </ButtonGroup>
                    </Col>
                </Row>
            </ScreeningFormGeneralField>
        </div>
    )
}

export default ScreeningFormMap;
